import { ReferenceQuestionReviewType } from '@examdojo/review';

export enum RootUrlParts {
  Syllabus = 'syllabus',
  Payment = 'payment',
  Overview = 'overview',
  Profile = 'profile',
}

export enum SyllabusUrlParts {
  Validate = 'validate',
}

export enum DerivativeQuestionUrlParts {
  PreScreening = 'pre-screening',
  Image = 'image',
  Final = 'final',
}

export const ReferenceQuestionUrlParts = ReferenceQuestionReviewType;

export enum ValidateUrlParts {
  DerivativeQuestion = 'derivative-question',
  ReferenceQuestion = 'reference-question',
}

export const DEFAULT_ROOT_URL_PART = RootUrlParts.Syllabus;
export const DEFAULT_SYLLABUS_URL_PART = SyllabusUrlParts.Validate;
export const DEFAULT_URL = `/${DEFAULT_ROOT_URL_PART}/:syllabusSlug/${DEFAULT_SYLLABUS_URL_PART}`;

export const SMALL_SCREEN_WIDTH = 768;
export const MEDIUM_SCREEN_WIDTH = 1000;
export const LARGE_SCREEN_WIDTH = 1400;
